import type { WBlogPopularPostsTranslations } from "./pl";

export const de: WBlogPopularPostsTranslations = {
  readMore: "Mehr lesen",
  empty: "Keine beliebten Beitrage.",
};
